/**
 * Stat card for analytics display
 */
export function StatCard({ label, value, isPercentage, icon, colorClass }) {
  return (
    <div className={`stat-card ${colorClass}`}>
      <div className="stat-icon">
        <i className={icon}></i>
      </div>
      <div className="stat-content">
        <h3>
          {value}
          {isPercentage && '%'}
        </h3>
        <p>{label}</p>
      </div>
    </div>
  );
}
